import React from "react";
import FrontierMark from "@/components/FrontierMark";

export default function Footer() {
    return (
        <footer className="mt-24 relative z-10" data-testid="site-footer">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10">
                <div
                    className="px-5 py-3 flex items-center justify-between"
                    style={{ background: "var(--ink)", color: "#CFD5DD" }}
                    data-testid="footer-ticker"
                >
                    <span className="font-mono-tech text-[10.5px] tracking-[0.15em] uppercase">
                        Frontier // Signal from the edge
                    </span>
                    <span className="font-mono-tech text-[10.5px] tracking-[0.15em] uppercase">
                        © {new Date().getFullYear()} · M1C
                    </span>
                </div>

                <div className="panel mt-2.5 p-8 md:p-12">
                    <FrontierMark size="lg" />
                    <p
                        className="mt-8 max-w-xl"
                        style={{ color: "var(--ink-2)", fontSize: 15, lineHeight: 1.6 }}
                    >
                        A private network for frontier builders and backers —
                        connecting investors, founders, and operators around the
                        companies defining the next era.
                    </p>
                </div>

                <div className="mt-2.5 mb-8 flex justify-end">
                    <span className="overline">By invitation. At the frontier.</span>
                </div>
            </div>
        </footer>
    );
}
